import {Box, Footer, Nav, Text} from "grommet";
import {CircleInformation, Home, Shop, Tag} from "grommet-icons";
import React, {useEffect, useState} from "react";
import {NavLink} from "react-router-dom";
import {style} from "./style.css";
import api from "../../utils/api";
import {getUserId} from "../../utils/token";

const FooterApp = (props) => {
    const [customerPoints, setCustomerPoints] = useState();
    useEffect(() => {
        api.get(process.env.REACT_APP_BASE_API_URL + 'api/users/' + getUserId())
            .then(response => {
                let points = response.data.fidelityCards?.[0] ? response.data.fidelityCards?.[0].points : 0
                setCustomerPoints(points);
            })
            .catch(error => {
                console.error(error);
            });
    }, []);
    return (
        <>
            <Footer
                background="brand"
                pad="small"
                align={"end"}
                height={"xsmall"}
                direction={"row-reverse"} >
                <Text
                    size={"large"}
                    weight={"bolder"}
                    alignSelf={"center"}
                    margin={"small"}
                    color={"white"}>{customerPoints}pt</Text>
            </Footer>
            <Footer id="footer"
                    align="center"
                    justify="center"
                    gap="large"
                    margin={"none"}
                    pad={"none"}
                    fill={"horizontal"}
                    width={"large"}>
                <Nav direction="row"
                     background={"white"}
                     pad="medium"
                     gap={"xlarge"}
                     align="center"
                     justify="center"
                     fill={"horizontal"}>
                    <NavLink to="/">
                        <Box
                            direction={"column"}
                            align={"center"}
                            justify={"center"}
                            alignContent={"center"}
                        >
                            <Home/>
                        </Box>
                    </NavLink>
                    <NavLink to="/offers">
                        <Box
                            direction={"column"}
                            align={"center"}
                            justify={"center"}
                            alignContent={"center"}
                        >
                            <Tag/>
                        </Box>

                    </NavLink>
                    <NavLink to="/stores">
                        <Box
                            direction={"column"}
                            align={"center"}
                            justify={"center"}
                            alignContent={"center"}
                        >
                            <Shop/>
                        </Box>
                    </NavLink>
                    <NavLink to="/info">
                        <Box
                            direction={"column"}
                            align={"center"}
                            justify={"center"}
                            alignContent={"center"}
                        >
                            <CircleInformation/>
                        </Box>
                    </NavLink>
                </Nav>
            </Footer>
        </>
    )
        ;
};

export default FooterApp